var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-col', {
    staticClass: "text-center py-10 py-lg-40",
    attrs: {
      "cols": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "pb-20 pb-md-34 border-bottom h-100"
  }, [_c('v-img', {
    staticClass: "w-100 mb-12 mb-lg-24",
    attrs: {
      "src": _vm.src
    }
  }), _c('p', {
    staticClass: "page-text-lg font-weight-medium mb-4 mb-lg-10"
  }, [_vm._t("default")], 2), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" " + _vm._s(_vm.num) + " ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }